import { GetDetailsSettings, GetVenueSettings, GetVenueTypeSettings, GetSearchSettings, GetgeneralSettings, GetPaymentSettings } from "../../../server/config";

export const adminStore = {
  namespaced: true,
  state() {
    return {
      generalSettings: {},
      searchSettings: {},
      detailSettings: {},
      venueSettings: [],
      paymentSettings:[],
      venuetypesetting: []

    };
  },
  mutations: {
    setGeneral(state, general) {
      state.generalSettings = { ...state.generalSettings, ...general };
    },
    setSearchSettings(state, data) {
      state.searchSettings = data;
    },
    setDetailSettings(state, data) {
      state.detailSettings = data;
    },
    setVenueSettings(state, data) {
      state.venueSettings = data
    },
    setPaymentSettings(state, data){
      state.paymentSettings = data
    },
    setVenueTypeSettings(state, data) {
      state.venuetypesetting = data
    }
  },
  actions: {
    // async adminGetConfig(context) {
    //   const [data] = await getConfig();
    //   console.log(data,"datadatadata");
    //   context.commit("setGeneral", data.generalSettings);
    //   context.commit("setSearchSettings", data.searchSettings);
    //   context.commit("setDetailSettings", data.detailSettings);
    //   context.commit("setVenueSettings", data.venueSettings);
    //   context.commit("setVenueTypeSettings", data.venuetypesetting)
    // },
    async adminGetSearchSettings(context) {
      const data = await GetSearchSettings();
      context.commit("setSearchSettings", data?.data);
    },
    async adminGetVenueSettings(context) {
      const data = await GetVenueSettings();
      context.commit("setVenueSettings", data?.data);
    },
    async adminGetDetailsSettings(context) {
      const data = await GetDetailsSettings();
      context.commit("setDetailSettings", data?.data);
    },
    async adminGetGeneralSettings(context) {
      const data = await GetgeneralSettings();
      context.commit("setGeneral", data?.data);
    },
    async adminGetPaymentSetting(context){
      const data = await GetPaymentSettings();
      context.commit("setPaymentSettings", data?.data)
    },
    async adminvenueTypeSettings(context) {
      const data = await GetVenueTypeSettings();
      context.commit("setVenueTypeSettings", data?.data)
    },
    // async adminSaveConfig(context) {
    //   await saveConfig({
    //     generalSettings: context.state.generalSettings,
    //     detailSettings: context.state.detailSettings,
    //     searchSettings: context.state.searchSettings,
    //     venueSettings: context.state.venueSettings,
    //     venuetypesetting: context.state.venuetypesetting
    //   });
    // },

  },
};